// extracted by mini-css-extract-plugin
module.exports = {"agreementWrapper":"Agreement_agreementWrapper__1-vBi","chapterContentWrapper":"Agreement_chapterContentWrapper__RY7px"};